import { atom } from 'jotai'

/**
 * 車両グループフィルタの状態管理
 * 総量表示モーダルから車両グループをクリックした際に設定される
 */
export const truckGroupFilterAtom = atom<number[] | null>(null)

truckGroupFilterAtom.debugLabel = 'truckGroupFilterAtom'
